"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COORDINATE_UNDATED_NOVASOL_SEARCH_RESPONSE = exports.COORDINATE_FLEX_SEARCH_RESPONSE = exports.COORDINATE_DATED_SEARCH_RESPONSE = exports.COORDINATE_UNDATED_SEARCH_RESPONSE_V2 = exports.COORDINATE_UNDATED_SEARCH_RESPONSE = void 0;
exports.COORDINATE_UNDATED_SEARCH_RESPONSE = {
    total: 1,
    from: 0,
    size: 12,
    rhsLevel: 'rhs1',
    searchResults: [
        {
            code: 'FCK',
            coordinate: {
                lat: '-4.390309',
                lon: '50.73595',
            },
        },
    ],
    aggregations: {
        accommodationTypes: [],
        features: [
            {
                featureId: '9999',
                featureName: 'Shiny Feature',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '9857',
                featureName: 'Pets Allowed',
                featureCode: null,
                count: 1,
            },
        ],
        siteFeatures: [],
        bathrooms: [
            {
                bathrooms: 3,
                count: 1,
            },
        ],
        bedrooms: [
            {
                bedrooms: 2,
                count: 1,
            },
        ],
        regions: {
            rhs1: [
                {
                    count: 1,
                    regionName: 'England',
                    regionCode: 21667,
                },
            ],
            rhs2: [
                {
                    count: 1,
                    regionName: 'North West England',
                    regionCode: 21952,
                },
            ],
            rhs3: [
                {
                    count: 1,
                    regionName: 'Cheshire',
                    regionCode: 21953,
                },
            ],
            rhs4: [
                {
                    count: 1,
                    regionName: 'Cheshire',
                    regionCode: 21954,
                },
            ],
            rhs5: [
                {
                    count: 1,
                    regionName: 'Chester',
                    regionCode: 21955,
                },
            ],
        },
        grades: [
            {
                grade: '4',
                count: 1,
            },
        ],
        reviews: [
            {
                score: 0,
                count: 0,
            },
            {
                score: 1,
                count: 0,
            },
            {
                score: 2,
                count: 0,
            },
            {
                score: 3,
                count: 1,
            },
            {
                score: 4,
                count: 0,
            },
            {
                score: 5,
                count: 0,
            },
        ],
    },
};
exports.COORDINATE_UNDATED_SEARCH_RESPONSE_V2 = {
    total: 1,
    from: 0,
    size: 12,
    rhsLevel: 'rhs1',
    searchResults: [
        {
            code: 'FCK',
            coordinate: {
                lat: '-4.390309',
                lon: '50.73595',
            },
        },
    ],
    aggregations: {
        accommodationTypes: [],
        features: [
            {
                featureId: 'ent_wifiac',
                count: 51850,
                featureCode: 'DerivedFeature',
            },
            {
                featureId: 'ent_parkingonsite',
                count: 46729,
                featureCode: 'DerivedFeature',
            },
            {
                featureId: 'ent_washingmachine',
                count: 44605,
                featureCode: 'StandardFeature',
            },
        ],
        popularFeatures: [
            {
                featureId: 'ent_wifiac',
                count: 51850,
                featureCode: 'DerivedFeature',
                featureName: null
            }
        ],
        siteFeatures: [],
        bathrooms: [
            {
                bathrooms: 3,
                count: 1,
            },
        ],
        bedrooms: [
            {
                bedrooms: 2,
                count: 1,
            },
        ],
        grades: [
            {
                grade: '4',
                count: 1,
            },
        ],
        reviews: [
            {
                score: 0,
                count: 0,
            },
            {
                score: 1,
                count: 0,
            },
            {
                score: 2,
                count: 0,
            },
            {
                score: 3,
                count: 1,
            },
            {
                score: 4,
                count: 0,
            },
            {
                score: 5,
                count: 0,
            },
        ],
    },
};
exports.COORDINATE_DATED_SEARCH_RESPONSE = {
    total: 1,
    from: 0,
    size: 12,
    rhsLevel: 'rhs1',
    searchResults: [
        {
            code: 'FCK',
            coordinate: {
                lat: '-4.390309',
                lon: '50.73595',
            },
        },
    ],
    aggregations: {
        accommodationTypes: [],
        features: [
            {
                featureId: '9999',
                featureName: 'Shiny Feature',
                featureCode: null,
                count: 1,
            },
        ],
        siteFeatures: [],
        bathrooms: [
            {
                bathrooms: 3,
                count: 1,
            },
        ],
        bedrooms: [
            {
                bedrooms: 2,
                count: 1,
            },
        ],
        regions: {
            rhs1: [
                {
                    count: 1,
                    regionName: 'England',
                    regionCode: 21667,
                },
            ],
            rhs2: [
                {
                    count: 1,
                    regionName: 'North West England',
                    regionCode: 21952,
                },
            ],
            rhs3: [
                {
                    count: 1,
                    regionName: 'Cheshire',
                    regionCode: 21953,
                },
            ],
            rhs4: [
                {
                    count: 1,
                    regionName: 'Cheshire',
                    regionCode: 21954,
                },
            ],
            rhs5: [
                {
                    count: 1,
                    regionName: 'Chester',
                    regionCode: 21955,
                },
            ],
        },
        grades: [
            {
                grade: '4',
                count: 1,
            },
        ],
        reviews: [
            {
                score: 0,
                count: 0,
            },
            {
                score: 1,
                count: 0,
            },
            {
                score: 2,
                count: 0,
            },
            {
                score: 3,
                count: 1,
            },
            {
                score: 4,
                count: 0,
            },
            {
                score: 5,
                count: 0,
            },
        ],
    },
};
exports.COORDINATE_FLEX_SEARCH_RESPONSE = {
    total: 1,
    from: 0,
    size: 12,
    rhsLevel: 'rhs1',
    searchResults: [
        {
            code: 'FCK',
            coordinate: {
                lat: '-4.390309',
                lon: '50.73595',
            },
        },
    ],
    aggregations: {
        accommodationTypes: [],
        features: [
            {
                featureId: '9999',
                featureName: 'Shiny Feature',
                featureCode: null,
                count: 1,
            },
        ],
        siteFeatures: [],
        bathrooms: [
            {
                bathrooms: 3,
                count: 1,
            },
        ],
        bedrooms: [
            {
                bedrooms: 2,
                count: 1,
            },
        ],
        regions: {
            rhs1: [
                {
                    count: 1,
                    regionName: 'England',
                    regionCode: 21667,
                },
            ],
            rhs2: [
                {
                    count: 1,
                    regionName: 'North West England',
                    regionCode: 21952,
                },
            ],
            rhs3: [
                {
                    count: 1,
                    regionName: 'Cheshire',
                    regionCode: 21953,
                },
            ],
            rhs4: [
                {
                    count: 1,
                    regionName: 'Cheshire',
                    regionCode: 21954,
                },
            ],
            rhs5: [
                {
                    count: 1,
                    regionName: 'Chester',
                    regionCode: 21955,
                },
            ],
        },
        grades: [
            {
                grade: '4',
                count: 1,
            },
        ],
        reviews: [
            {
                score: 0,
                count: 0,
            },
            {
                score: 1,
                count: 0,
            },
            {
                score: 2,
                count: 0,
            },
            {
                score: 3,
                count: 1,
            },
            {
                score: 4,
                count: 0,
            },
            {
                score: 5,
                count: 0,
            },
        ],
    },
};
exports.COORDINATE_UNDATED_NOVASOL_SEARCH_RESPONSE = {
    total: 1,
    from: 0,
    size: 12,
    rhsLevel: 'rhs1',
    searchResults: [
        {
            code: 'FCK',
            coordinate: {
                lat: '-4.390309',
                lon: '50.73595',
            },
        },
    ],
    aggregations: {
        accommodationTypes: [
            {
                accommodationId: 'ACCOM-2',
                count: 103,
            },
            {
                accommodationId: 'ACCOM-3',
                count: 32803,
            },
            {
                accommodationId: 'ACCOM-1',
                count: 13419,
            },
        ],
        features: [
            {
                featureId: 'FILT-11',
                count: 42722,
            },
            {
                featureId: 'FILT-7',
                count: 7651,
            },
            {
                featureId: 'FILT-34',
                count: 4296,
            },
            {
                featureId: 'FILT-13',
                count: 7600,
            },
            {
                featureId: 'FILT-22',
                count: 3697,
            },
            {
                featureId: 'FILT-17',
                count: 1409,
            },
            {
                featureId: 'FILT-3',
                count: 32898,
            },
            {
                featureId: 'FILT-28',
                count: 70,
            },
            {
                featureId: 'FILT-18',
                count: 5375,
            },
            {
                featureId: 'FILT-24',
                count: 18686,
            },
            {
                featureId: 'FILT-6',
                count: 30169,
            },
            {
                featureId: 'FILT-1',
                count: 20199,
            },
            {
                featureId: 'FILT-14',
                count: 2669,
            },
            {
                featureId: 'FILT-4',
                count: 17624,
            },
            {
                featureId: 'FILT-2',
                count: 505,
            },
            {
                featureId: 'FILT-9',
                count: 1407,
            },
            {
                featureId: 'FILT-30',
                count: 22448,
            },
            {
                featureId: 'FILT-5',
                count: 40955,
            },
            {
                featureId: 'FILT-19',
                count: 1838,
            },
            {
                featureId: 'FILT-29',
                count: 2196,
            },
            {
                featureId: 'FILT-10',
                count: 13717,
            },
            {
                featureId: 'FILT-16',
                count: 1274,
            },
            {
                featureId: 'FILT-8',
                count: 374,
            },
            {
                featureId: 'FILT-21',
                count: 7053,
            },
            {
                featureId: 'FILT-27',
                count: 3308,
            },
            {
                featureId: 'FILT-35',
                count: 966,
            },
            {
                featureId: 'FILT-12',
                count: 34579,
            },
            {
                featureId: 'FILT-25',
                count: 2600,
            },
            {
                featureId: 'FILT-15',
                count: 15795,
            },
            {
                featureId: 'FILT-31',
                count: 19891,
            },
            {
                featureId: 'FILT-33',
                count: 29497,
            },
            {
                featureId: 'FILT-32',
                count: 26436,
            },
            {
                featureId: 'FILT-20',
                count: 3802,
            },
            {
                featureId: 'FILT-26',
                count: 15364,
            },
            {
                featureId: 'FILT-23',
                count: 34617,
            },
        ],
        siteFeatures: [],
        bathrooms: [
            {
                bathrooms: 0,
                count: 142,
            },
            {
                bathrooms: 10,
                count: 58,
            },
            {
                bathrooms: 1,
                count: 28097,
            },
            {
                bathrooms: 2,
                count: 11614,
            },
            {
                bathrooms: 3,
                count: 3335,
            },
            {
                bathrooms: 4,
                count: 1772,
            },
            {
                bathrooms: 5,
                count: 746,
            },
            {
                bathrooms: 6,
                count: 347,
            },
            {
                bathrooms: 7,
                count: 134,
            },
            {
                bathrooms: 8,
                count: 70,
            },
            {
                bathrooms: 9,
                count: 23,
            },
        ],
        bedrooms: [
            {
                bedrooms: 0,
                count: 1426,
            },
            {
                bedrooms: 10,
                count: 143,
            },
            {
                bedrooms: 1,
                count: 6998,
            },
            {
                bedrooms: 2,
                count: 14298,
            },
            {
                bedrooms: 3,
                count: 13060,
            },
            {
                bedrooms: 4,
                count: 6690,
            },
            {
                bedrooms: 5,
                count: 2103,
            },
            {
                bedrooms: 6,
                count: 931,
            },
            {
                bedrooms: 7,
                count: 378,
            },
            {
                bedrooms: 8,
                count: 201,
            },
            {
                bedrooms: 9,
                count: 110,
            },
        ],
        regions: {
            rhs1: [],
            rhs2: [],
            rhs3: [],
            rhs4: [],
            rhs5: [],
        },
        grades: [
            {
                grade: '1',
                count: 37,
            },
            {
                grade: '2',
                count: 1597,
            },
            {
                grade: '3',
                count: 18518,
            },
            {
                grade: '4',
                count: 18070,
            },
            {
                grade: '5',
                count: 8102,
            },
        ],
        reviews: [],
    },
};
//# sourceMappingURL=coordinates.js.map